import React, { FC } from "react";
import classNames from "classnames";
import InfiniteScroll from "react-infinite-scroller";
import { Spinner } from "@app/components/common/icons";
import { ArticlePreviewCard } from "@app/components/article-preview-card/ArticlePreviewCard";
import { PostSummary } from "@app/models";
import { ELEMENTS_PER_PAGE } from "../../constants";

type Props = {
  list: PostSummary[];
  currentPage: number;
  setCurrentPage: () => void;
};

export const ArticlesList: FC<Props> = ({
  list,
  currentPage,
  setCurrentPage,
}) => {
  const articlesToDisplay = list.filter(
    (article, index) => index < currentPage * ELEMENTS_PER_PAGE,
  );

  return (
    <div role="tabpanel" className={classNames("tab-content block")}>
      <InfiniteScroll
        loadMore={setCurrentPage}
        hasMore={list.length > currentPage * ELEMENTS_PER_PAGE}
        loader={
          <div className="flex justify-center py-10" key={"spinner"}>
            <Spinner className="h-8 w-8 stroke-primary-content" />
          </div>
        }
      >
        <div
          className={classNames(
            "grid grid-cols-1 gap-x-5 gap-y-15",
            "md:grid-cols-2",
            "lg:gap-x-10",
            "xxl:grid-cols-6 xxl:gap-x-12 xxl:gap-y-25",
          )}
        >
          {articlesToDisplay?.map((article, index) => {
            const isWide = index % 8 >= 6;

            return (
              <ArticlePreviewCard
                {...article}
                key={article.uuid}
                className={classNames({
                  "xxl:col-span-3": isWide,
                  "xxl:col-span-2": !isWide,
                })}
                imageClassName={isWide ? "xxl:aspect-[6/5]" : undefined}
              />
            );
          })}
        </div>
      </InfiniteScroll>
    </div>
  );
};
